<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<{
    class?: HTMLAttributes['class'];
  }>();
</script>

<template>
  <tr :class="cn('data-[state=selected]:bg-table-selected!', props.class)">
    <slot />
  </tr>
</template>
